module.exports = __webpack_public_path__ + "static/img/pd_detail_7.9eba632.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerpic/footerDetailPic/pd_detail_7.jpg
// module id = sALp
// module chunks = 51